const VisuallyHiddenError = () => {    
    return (
        <span style={{ position: 'absolute', top: 'auto', overflow: 'hidden', width: '1px', height: '1px', whiteSpace: 'nowrap', clip: "rect(1px, 1px, 1px, 1px)" }}>Error:</span>
    )
}

export default VisuallyHiddenError;